<template>
  <b-container class="p-3" fluid>
    <h5>
      รายละเอียดการใช้จ่ายงบประมาณของ
      {{ groupFunding.group.name }}
    </h5>
    <h6 class="text-secondary">
      ปีการศึกษา
      <b-badge style="font-size: 1em;">{{ groupFunding.acYear.year }}</b-badge>
    </h6>
    <h6 :style="{ 'font-size':14+'px' }" class="text-muted">
      หมายเหตุ:
    </h6>
    <ul>
      <li>ชุมนุมสังกัดสโมสรนักศึกษา ใช้งบประมาณแหล่งเดียวกันกับสโมสรนักศึกษา</li>
      <li>ยอดเงินที่ใช้จริงจะอัพเดท<u>หลังสนง.กิจการนักศึกษาอนุมัติปิดโครงการ</u></li>
    </ul>
    <budget-detail :group-funding="groupFunding" />
  </b-container>
</template>

<script>
import BudgetDetail from '@/components/budget/BudgetDetail'
import gql from 'graphql-tag'

export default {
  components: { BudgetDetail },
  apollo: {
    groupFunding: {
      query: gql`
        query GetGroupFunding($id: ID!) {
          groupFunding(id: $id) {
            receivedAmount
            usedAmount
            groupFundingTransactions {
              requestedAmount
              usedAmount
              returnedAmount
              project {
                name
                group {
                  name
                }
              }
              updated_at
            }
            acYear {
              year
            }
            group {
              name
            }
          }
        }
      `,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  }
}
</script>
